export default __webpack_public_path__ + "static/media/logo (4).3ab37315.png";